
var Accordion = (function() {

    function Accordion(el, toggle) {
        var self = this;
        this.el = el;
        this.toggle = toggle;
        this.toggle.style =  this.toggle.style || {};
        this.toggle.style.transition = 'transform 300ms ease';
        this.toggle.addEventListener('click', function(event) {
            event.preventDefault();
            if (!this.animating) toggleAccordion(self);
        });
        this.duration = 400;
        this.animating = false;
        if (this.el.dataset.state == 'closed') {
            this.el.style.display = 'none';
        }
    }

    function animate(draw, duration, cb) {
        var start = performance.now();
        requestAnimationFrame(function animate(time) {
            var elapsed = time - start;
            var progress = Math.min(elapsed / duration, 1);

            draw(progress);

            if (elapsed < duration) requestAnimationFrame(animate);
            else if (cb) cb();
        });
    }

    function close(accordion) {
        accordion.animating = true;
        var height = accordion.el.offsetHeight;
        accordion.el.style.overflow = 'hidden';
        accordion.el.style.height = height;
        animate(function(progress) {
            accordion.el.style.height = height - (height * progress) + 'px';
        }, accordion.duration, function() {
            accordion.animating = false;
            accordion.el.style.display = 'none';
            accordion.el.style.removeProperty('height');
            accordion.el.style.removeProperty('overflow');
        });
    }

    function open(accordion) {
        accordion.animating = true;
        accordion.el.style.overflow = 'hidden';
        accordion.el.style.display = 'block';
        var height = accordion.el.offsetHeight;
        accordion.el.style.height = 0;
        animate(function(progress) {
            accordion.el.style.height = (height * progress) + 'px';
        }, accordion.duration, function() {
            accordion.animating = false;
            accordion.el.style.removeProperty('display');
            accordion.el.style.removeProperty('height');
            accordion.el.style.removeProperty('overflow');
        });
    }

    function toggleAccordion(accordion) {
        if (accordion.el.dataset.state == 'open') {
            accordion.el.dataset.state = 'close';
            accordion.toggle.style.transform = 'rotate(0deg)';
            close(accordion);
        } else {
            accordion.el.dataset.state = 'open';
            accordion.toggle.style.transform = 'rotate(45deg)';
            open(accordion);
        }
    }

    return Accordion;
}());

export default Accordion;
